import Container from 'react-bootstrap/Container';
import Carousel from 'react-bootstrap/Carousel';
import React from 'react';
import './testimonials.css';

var testimonialsData = [
  {
    id: 1,
    name: 'Ana Silva',
    description: 'Como psicóloga e ex-aluna da Escola do ISPA, posso dizer que minha experiência lá foi extremamente enriquecedora. A qualidade do ensino e a abordagem humanista adotada pela instituição me proporcionaram uma base sólida para minha carreira. Além disso, os professores são altamente qualificados e acessíveis, o que contribuiu significativamente para o meu desenvolvimento acadêmico e pessoal. Estou muito grata pela formação que recebi na Escola do ISPA."',
    designation: 'Psicóloga'
  },
  {
    id: 2,
    name: 'Pedro Martins',
    description: '"Estudar na Escola do ISPA tem sido uma jornada incrível para mim. Desde o primeiro dia, fui acolhido por uma comunidade vibrante e diversificada, onde pude explorar meus interesses acadêmicos e participar de diversas atividades extracurriculares. A infraestrutura da escola é moderna e bem equipada, proporcionando um ambiente propício para o aprendizado. Além disso, os projetos de pesquisa e extensão oferecidos pela instituição me permitiram expandir meus horizontes e me preparar para os desafios do futuro."',
    designation: 'Estudante'
  },
  {
    id: 3,
    name: 'Lucrecia Dos Santos',
    description: '"Como professora da Escola do ISPA, posso afirmar que a instituição está comprometida com a excelência acadêmica e o desenvolvimento integral de seus alunos. Aqui, temos a liberdade de inovar em nossas práticas pedagógicas e de colaborar com uma equipe dedicada e apaixonada pelo ensino. A Escola do ISPA valoriza o diálogo e o pensamento crítico, preparando seus alunos não apenas para o sucesso acadêmico, mas também para serem cidadãos conscientes e engajados em sua comunidade. Estou orgulhosa de fazer parte desta instituição.',
    designation: 'Professora'
  }
]

function AppTestimonials() {
  return (
    <section id="testimonials" className="testimonials-block modern-testimonials">
      <Container fluid>
        <div className="title-holder text-center mb-5">
          <h2 className="fw-bold text-white">Depoimentos</h2>
          <div className="subtitle text-white">O que dizem sobre a nossa instituição</div>
        </div>
        <div className="carousel-container" style={{ position: 'relative', overflow: 'hidden' }}>
          <Carousel
            controls={true}
            indicators={true}
            interval={7000}
            fade
            className="testimonials-carousel custom-carousel-controls"
            nextIcon={
              <span
                aria-hidden="true"
                className="carousel-control-next-icon custom-next"
              />
            }
            prevIcon={
              <span
                aria-hidden="true"
                className="carousel-control-prev-icon custom-prev"
              />
            }
            pause={false}
            ride="carousel"
          >
            {testimonialsData.map((testimonial) => (
              <Carousel.Item key={testimonial.id}>
                <div className="testimonial-content d-flex flex-column align-items-center">
                  <div className="testimonial-icon mb-3">
                  </div>
                  <blockquote className="blockquote text-center">
                    <p className="mb-4 fs-5 fst-italic text-white">{testimonial.description}</p>
                    <footer className="blockquote-footer text-white">
                      <span className="fw-semibold">{testimonial.name}</span>
                      <span className="ms-2" style={{color:'#00761F'}}>{testimonial.designation}</span>
                    </footer>
                  </blockquote>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </Container>
    </section>
  );
}

export default AppTestimonials;